const columns = [
  {
    title: 'Login',
    dataIndex: 'login',
    // sorter: (a, b) => a?.login - b?.login,
  },
  {
    title: 'Platform',
    dataIndex: 'platform',
    // sorter: (a, b) => a?.platform?.localeCompare(b?.platform),
  },
  {
    title: 'A/C Type',
    dataIndex: 'acType',
    // sorter: (a, b) => a?.acType?.localeCompare(b?.acType),
  },
  {
    title: 'Balance',
    dataIndex: 'balances',
  },
  {
    title: 'Leverage',
    dataIndex: 'leverage',
    // sorter: (a, b) => a?.leverage - b?.leverage,
  },
  {
    title: 'Currency',
    dataIndex: 'currency',
    // sorter: (a, b) => a?.currency?.localeCompare(b?.currency),
  },

  {
    title: 'Created At',
    dataIndex: 'createdAt',
    // sorter: (a, b) => ((new Date(a.createdAt)) - (new Date(b.createdAt))),
  },
  {
    title: 'Trading Terminal',
    render: () =>
      <a href='https://terminal.rimglobal.trade/terminal' target='_blank' rel='noopener noreferrer' className='text-blue-500 hover:text-blue-700 underline'>
        Web Trader
      </a>,
  },
  {
    title: 'Status',
    dataIndex: 'status',
  },
];

export default columns;